import { AGE_BANDS, JOBS, GENDERS } from "../demographics.js";
import Choice from "./Choice.jsx";

/**
 * 연구·통계 선택 동의 한 덩어리. 입장 화면·저장 시트·가입 폼이 모두 이걸 쓴다.
 *
 * 네 군데에 같은 문구와 같은 규칙을 따로 쓰면 언젠가 한 곳만 어긋난다.
 * 특히 **기본값이 꺼짐이라는 것**과 **동의해야만 인구통계를 묻는다는 것**은
 * 어느 화면에서도 달라지면 안 된다.
 *
 * ★ 체크를 켜면 그 자리에서 칩이 펼쳐진다.
 * 별도 화면으로 보내면 거기서 끊긴다 — 체크를 켠 순간이 가장 열려 있는 순간이다.
 * 반대로 안 켠 사람에게는 화면이 그대로다. 막지 않는다.
 */
export default function ConsentChoice({ agreed, onAgreed, who, onWho, compact = false }) {
  const set = (k) => (v) => onWho({ ...who, [k]: v });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <label className="card" style={{
        flexDirection: "row", alignItems: "flex-start", gap: 12,
        padding: compact ? "13px 15px" : "16px 18px", borderRadius: 4,
      }}>
        <input type="checkbox" checked={agreed} onChange={(e) => onAgreed(e.target.checked)}
          style={{ width: 22, height: 22, flexShrink: 0, marginTop: 1, accentColor: "#15151A" }} />
        <span style={{ display: "flex", flexDirection: "column", gap: 3 }}>
          <span style={{ fontSize: compact ? 15 : 16, fontWeight: 800 }}>
            내 토론을 연구·통계에 써도 좋아요 <span style={{ color: "var(--muted)", fontWeight: 700 }}>(선택)</span>
          </span>
          <span className="note">
            서비스를 좋게 만들고, 개인을 알아볼 수 없는 통계를 만드는 데 씁니다.
            안 하셔도 토론은 그대로 됩니다. 언제든 그만둘 수 있어요.{" "}
            <a href="https://sowhat.run/privacy" target="_blank" rel="noreferrer"
              onClick={(e) => e.stopPropagation()} style={{ textDecoration: "underline" }}>자세히</a>
          </span>
        </span>
      </label>

      {/* 동의하지 않은 사람에게는 묻지 않는다. 안 쓸 값을 받아 두는 게 곧 과잉 수집이다. */}
      {agreed && (
        <div className="card" style={{ gap: 14, padding: "16px 18px", borderRadius: 4 }}>
          <span style={{ fontSize: 15, fontWeight: 800 }}>
            괜찮으시면 이것도 알려주세요 <span style={{ color: "var(--muted)", fontWeight: 700 }}>(선택)</span>
          </span>
          <p className="note" style={{ margin: 0 }}>
            <strong>연령대를 넣으시면 결과에서 또래와도 비교해드려요.</strong>{" "}
            생년월일이나 직장이 아니라 구간만 받고, 안 고르셔도 괜찮아요.
          </p>
          <Choice label="연령대" options={AGE_BANDS} value={who.ageBand} onChange={set("ageBand")} />
          <Choice label="직군" options={JOBS} value={who.job} onChange={set("job")} />
          <Choice label="성별" options={GENDERS} value={who.gender} onChange={set("gender")} />
        </div>
      )}
    </div>
  );
}

export const EMPTY_WHO = { ageBand: null, job: null, gender: null };
